import React from 'react';
import { AlertCircle } from 'lucide-react';

export const FieldError = ({ error, theme }) => {
  if (!error) return null;
  
  return (
    <p className={theme.error}>
      <AlertCircle size={12} className="mr-1" />
      {error.message || 'This field is required'}
    </p>
  );
};